(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ps-testimonials"] && !Shopify.designMode) return;
  try {
    

  
  
  $(document).ready(function(){
  $(".owl-carousel").owlCarousel({
//      autoplay:true,
      margin:30,
      loop:true,
      dots:true,
//      nav:true,
     responsiveClass:true,
    responsive:{
        0:{
            items:1,
            nav:true
        },
        600:{
            items:3,
            nav:true
        },
        1000:{
            items:3,
            nav:true,
            loop:true
        }
    }
     
//      navText:["<i class='fas fa-long-arrow-alt-left'></i>","<i class='fas fa-long-arrow-alt-right'></i>" ]
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tcsc-bedroom"] && !Shopify.designMode) return;
  try {
    
function initBedroom(root){if(root.dataset.ready)return;root.dataset.ready='true';const grid=root.querySelector('#products');const cards=Array.from(grid.querySelectorAll('.product'));const buttons=Array.from(root.querySelectorAll('[data-filter]'));const sort=root.querySelector('#sort');const count=root.querySelector('[data-count-template]');let filter='all';function update(){const mode=sort.value;cards.sort((a,b)=>mode==='low'?Number(a.dataset.price)-Number(b.dataset.price):mode==='high'?Number(b.dataset.price)-Number(a.dataset.price):Number(a.dataset.order)-Number(b.dataset.order));cards.forEach(c=>{c.hidden=filter!=='all'&&c.dataset.category!==filter;grid.appendChild(c)});count.textContent=count.dataset.countTemplate.replace('[count]',cards.filter(c=>!c.hidden).length);buttons.forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.filter===filter)))}buttons.forEach(b=>b.addEventListener('click',()=>{filter=b.dataset.filter;update()}));sort.addEventListener('change',update);update()}document.querySelectorAll('.tcsc-bedroom').forEach(initBedroom);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('.tcsc-bedroom').forEach(initBedroom));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tcsc-bespoke-gallery"] && !Shopify.designMode) return;
  try {
    
function initTcscGalleries(){document.querySelectorAll('.tc-gallery').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='true';const filters=root.querySelector('.bg-filters');if(!filters)return;filters.hidden=false;filters.addEventListener('click',event=>{const button=event.target.closest('button[data-category]');if(!button)return;const category=button.dataset.category;filters.querySelectorAll('button').forEach(item=>item.setAttribute('aria-pressed',String(item===button)));let count=0;root.querySelectorAll('.bg-piece').forEach(piece=>{const show=category==='all'||piece.dataset.category===category;piece.hidden=!show;if(show)count++;});root.querySelector('[data-count]').textContent=count;});});}initTcscGalleries();document.addEventListener('shopify:section:load',initTcscGalleries);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tcsc-outdoor-gallery"] && !Shopify.designMode) return;
  try {
    
function initTcscGalleries(){document.querySelectorAll('.tc-gallery').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='true';const filters=root.querySelector('.bg-filters');if(!filters)return;filters.hidden=false;filters.addEventListener('click',event=>{const button=event.target.closest('button[data-category]');if(!button)return;const category=button.dataset.category;filters.querySelectorAll('button').forEach(item=>item.setAttribute('aria-pressed',String(item===button)));let count=0;root.querySelectorAll('.bg-piece').forEach(piece=>{const show=category==='all'||piece.dataset.category===category;piece.hidden=!show;if(show)count++;});root.querySelector('[data-count]').textContent=count;});});}initTcscGalleries();document.addEventListener('shopify:section:load',initTcscGalleries);

  } catch(e) { console.error(e); }
})();
})();
